function getCreditNoteStatusBarLabel(creditNote) {
    let statusBarLabel = creditNote.status_label

    if (creditNote.status_label === "Draft") {
        statusBarLabel = "Draft Preview"
    }

    return statusBarLabel
}

export { getCreditNoteStatusBarLabel };
